import React from 'react'
import { NavLink, Redirect } from 'react-router-dom'
import Icon from 'components/common/elements/Icon'

import { settingsTabs } from './consts'

import styles from './Styles.scss'

const Settings = () => (
  <div className={styles.PageLayoutNavigations}>
    <h1 className={styles.PageTitle}>
      Settings
    </h1>
    { Object.keys(settingsTabs).map(tab =>{
      const {icon, path, label} = settingsTabs[tab];
      return(
        <NavLink key={tab}
                 to={path}
                 activeClassName={styles.tabItemActive}
                 className={styles.tabItem}>
        <div className={styles.tabItemIcon}>
          <Icon icon={icon} size={20}/>
        </div>
        <div className={styles.tabItemLabel}>
          <span className="gs-text">
            { label }
          </span>
        </div>
      </NavLink>)}
    )}
  </div>
)

export default Settings
